import { render, staticRenderFns } from "./message.vue?vue&type=template&id=63a99a08&scoped=true"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"
import style0 from "./message.vue?vue&type=style&index=0&id=63a99a08&prod&scoped=true&lang=scss"
import style1 from "./message.vue?vue&type=style&index=1&id=63a99a08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a99a08",
  null
  
)

export default component.exports